import React from "react";

import {makeStyles} from "@material-ui/core/styles";

import PrimaryButton from "../../../../components/Buttons/PrimaryButton";

import styles from "./styles";

const useStyles = makeStyles(styles);

const DetailsButton = ({onButtonClick, text='Zu Details', dataId, tooltip}) => {
  const classes = useStyles();

  return (
    <PrimaryButton
      dataId={dataId}
      onButtonClick={onButtonClick}
      variant={'text'}
      text={text}
      icon={<i className={"far fa-long-arrow-right"} style={{fontSize: 16, verticalAlign: 'middle'}}/>}
      iconPosition={'right'}
      tooltip={tooltip}
      customClasses={classes}
    />
  )
};

export default DetailsButton;